var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select',{attrs:{"id":_vm.id,"name":_vm.name,"placeholder":"Please Select...","type":"select","value":_vm.value,"options":_vm.ethnicityOptions,"error":_vm.error,"label":_vm.label},on:{"input":_vm.emitChange}})}
var staticRenderFns = []

export { render, staticRenderFns }